import { slide as Menu } from 'react-burger-menu'
import React from "react";
import "./NavBar.css"
import { NavLink ,useLocation,useNavigate} from 'react-router-dom';
const  NavBar = ()=> {

     const location=useLocation();
     console.log("location",location);
    let navigationLinks=[
    {pathName:"/",displayName:"Home",key:0},
    {pathName:"/about",displayName:"About",key:1},
    {pathName:"/skills",displayName:"Skills",key:2}];
    
    let key=0;
    return (
      <Menu>
        {navigationLinks.map((paths)=>
        <NavLink key={paths.key} to={paths.pathName} className={resolve(paths.pathName,location.pathname)}>
          {paths.displayName}
          </NavLink>)}
      </Menu>
    );
    }

   const resolve= (pathName,selectedLocation)=>{return pathName===selectedLocation?"menu-item active-item":"menu-item"};

export default NavBar ;